"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8274],{

/***/ 83539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ useSpecialistPageConfig; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(45077);
// EXTERNAL MODULE: ./hooks/useSpecialistPractices.ts
var useSpecialistPractices = __webpack_require__(90170);
// EXTERNAL MODULE: ./hooks/useVisibilityComponents.ts + 1 modules
var useVisibilityComponents = __webpack_require__(92422);
// EXTERNAL MODULE: ./hooks/useKeywordsMapper.ts
var useKeywordsMapper = __webpack_require__(46311);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./utils/strings.ts
var strings = __webpack_require__(5892);
// EXTERNAL MODULE: ./hooks/useBreadcrumbsSchema.ts + 1 modules
var useBreadcrumbsSchema = __webpack_require__(74022);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./hooks/useStatistic.tsx
var useStatistic = __webpack_require__(86512);
// EXTERNAL MODULE: ./utils/schema/address.ts
var address = __webpack_require__(57785);
// EXTERNAL MODULE: ./utils/address.ts
var utils_address = __webpack_require__(93953);
// EXTERNAL MODULE: ./utils/getImageFromNextImage.ts
var getImageFromNextImage = __webpack_require__(72566);
;// CONCATENATED MODULE: ./utils/getConsultationFeesString.ts
var getConsultationFeesString = function(param) {
    var newFees = param.newFees, followUpFees = param.followUpFees, currencySymbol = param.currencySymbol, isRtl = param.isRtl;
    if (!newFees && !followUpFees) {
        return "";
    }
    if (!newFees || !followUpFees) {
        return "".concat(currencySymbol).concat(newFees || followUpFees);
    }
    var fees = {
        min: "".concat(currencySymbol).concat(Math.min(newFees, followUpFees)),
        max: "".concat(currencySymbol).concat(Math.max(newFees, followUpFees))
    };
    return isRtl ? "".concat(fees.max, "-").concat(fees.min) : "".concat(fees.min, "-").concat(fees.max);
};
/* harmony default export */ var utils_getConsultationFeesString = (getConsultationFeesString);

// EXTERNAL MODULE: ./utils/price.ts
var price = __webpack_require__(98171);
;// CONCATENATED MODULE: ./utils/schema/specialist.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






// todo: fix complexity
// eslint-disable-next-line complexity
function getSpecialistSchema(specialist, lang, locale, translate, visibilityComponents, isRtl) {
    var ref12, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var idSchema = "https://www.doctify.com/".concat(locale, "/specialist/").concat(specialist.slug);
    var isEntry = specialist.basic || specialist.plan.includes("unclaimed");
    var topLevelKeyword = (ref12 = specialist === null || specialist === void 0 ? void 0 : specialist.keywords.filter(function(keyword) {
        return keyword.isTopLevelChild && keyword.keywordType === "specialty";
    })) === null || ref12 === void 0 ? void 0 : ref12[0];
    var subSpecialties = specialist === null || specialist === void 0 ? void 0 : specialist.keywords.filter(function(keyword) {
        return !keyword.isTopLevelChild && keyword.keywordType === "specialty";
    });
    var nameSchema = [
        specialist.title,
        specialist.fullName
    ].map(function(i) {
        return i === null || i === void 0 ? void 0 : i[lang];
    }).filter(function(i) {
        return (i === null || i === void 0 ? void 0 : i.length) > 1;
    }).join(" ");
    var mainPractice = specialist === null || specialist === void 0 ? void 0 : (ref1 = specialist.practices) === null || ref1 === void 0 ? void 0 : ref1.filter(utils_address/* removeVideoConsultation */.WM)[0];
    var addressToTransform = (0,utils_address/* getAddressFromPractices */.zz)(specialist === null || specialist === void 0 ? void 0 : specialist.practices);
    var mainPracticeAddress = addressToTransform ? (0,utils_address/* transformAddressToString */.CU)(addressToTransform, lang) : "";
    var specialtiesString = ((ref2 = subSpecialties.map(function(subSpec) {
        var ref;
        return subSpec === null || subSpec === void 0 ? void 0 : (ref = subSpec.name) === null || ref === void 0 ? void 0 : ref[lang];
    })) === null || ref2 === void 0 ? void 0 : ref2.join(", ")) || "";
    var aboutSchema = [
        "uk",
        "en-ae",
        "wpa"
    ].includes(locale) ? "".concat(nameSchema, " offers a range of ").concat(specialtiesString, " treatments and video consultations in ").concat(mainPracticeAddress, ". Read reviews and book online now.") : (((ref3 = specialist.about) === null || ref3 === void 0 ? void 0 : ref3[lang]) || "").replace(/<\/?[^>]+(>|$)/g, "").replace(/&rsquo;/g, "\u2019").replace(/&nbsp;/g, " ");
    var hospitalAffiliationSchema = specialist.practices.filter(utils_address/* removeVideoConsultation */.WM).filter(function(p) {
        var ref;
        return !!((ref = p.images) === null || ref === void 0 ? void 0 : ref.logo);
    }).map(function(practice) {
        var practiceUrl = "https://www.doctify.com/".concat(locale, "/practice/").concat(practice.slug);
        return {
            name: practice.name[lang],
            "@type": "Hospital",
            url: practiceUrl,
            sameAs: practiceUrl,
            address: (0,address/* default */.Z)(practice.address, lang),
            telephone: practice.ContactDetails.filter(function(cd) {
                return [
                    "public",
                    "singlePointPublic"
                ].includes(cd.type) && cd.phone;
            }).map(function(cd) {
                return cd.phone;
            }).join(", ")
        };
    });
    var memberOfSchema = (ref4 = specialist.insurers) === null || ref4 === void 0 ? void 0 : ref4.map(function(insurer) {
        return {
            name: insurer.name,
            "@type": "ProgramMembership",
            url: insurer.website,
            sameAs: insurer.website
        };
    });
    var aggregateRatingSchema = specialist.reviewsTotal > 0 ? {
        "@type": "AggregateRating",
        "@id": idSchema,
        identifier: idSchema,
        bestRating: 5,
        worstRating: 1,
        reviewCount: specialist.reviewsTotal,
        ratingValue: specialist.averageRating
    } : null;
    var potentialActionSchema = {
        "@type": "reserveAction",
        target: {
            "@type": "EntryPoint",
            urlTemplate: idSchema,
            actionPlatform: [
                "http://schema.org/DesktopWebPlatform",
                "http://schema.org/IOSPlatform",
                "http://schema.org/AndroidPlatform"
            ],
            inLanguage: locale
        },
        result: {
            "@type": "Reservation",
            name: translate("book_appointment")
        }
    };
    var practicesAddressesSchema = specialist.practices.filter(utils_address/* removeVideoConsultation */.WM).map(function(practice) {
        return (0,address/* default */.Z)(practice.address, lang);
    });
    var practicesGeoSchema = specialist.practices.filter(utils_address/* removeVideoConsultation */.WM).map(function(practice) {
        var ref;
        var ref13 = ((ref = practice.address) === null || ref === void 0 ? void 0 : ref.geolocation) || {}, lat = ref13.lat, lon = ref13.lon;
        return lat && lon ? {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lon
        } : null;
    }).filter(Boolean);
    var parseFee = function(fee) {
        if (!fee) {
            return;
        }
        var normalizedFee = String(fee).replace(",", ".");
        if (normalizedFee.includes("-")) {
            return parseFloat(normalizedFee.split("-")[0]);
        }
        return parseFloat(normalizedFee);
    };
    var ref11 = specialist.consultationFees || {}, newFee = ref11.new, followUp = ref11.followUp, currency = ref11.currency;
    var parsedNewFee = parseFee(newFee);
    var parsedFollowUpFee = parseFee(followUp);
    var currentCurrencySymbol = (0,price/* currencySymbol */.N)(((ref5 = specialist.consultationFees) === null || ref5 === void 0 ? void 0 : ref5.currency) || "", locale);
    var feesString = utils_getConsultationFeesString({
        currencySymbol: currentCurrencySymbol,
        isRtl: isRtl,
        followUpFees: parsedFollowUpFee,
        newFees: parsedNewFee
    });
    var isShowFeesSchema = !!currency && !isEntry && (!!newFee || !!followUp);
    var feesSchema = (isShowFeesSchema ? [
        newFee ? {
            price: newFee,
            priceCurrency: currency,
            name: translate("profile.new_appointment"),
            description: translate("profile.new_appointment")
        } : null,
        followUp ? {
            price: followUp,
            priceCurrency: currency,
            name: translate("profile.follow_up_appointemnt"),
            description: translate("profile.follow_up_appointemnt")
        } : null
    ] : []).filter(Boolean);
    var subSpecialtiesSchema = subSpecialties.map(function(subSpec) {
        var ref, ref14;
        return {
            price: "N/A",
            "@type": "Offer",
            name: (ref = subSpec.name) === null || ref === void 0 ? void 0 : ref[lang],
            url: idSchema,
            description: "".concat((ref14 = subSpec.name) === null || ref14 === void 0 ? void 0 : ref14[lang], " Specialist"),
            itemOffered: {
                "@type": "Service",
                url: idSchema
            }
        };
    });
    var makesOffer = [
        feesSchema
    ].concat(_toConsumableArray(subSpecialtiesSchema)).filter(Boolean);
    var faqQuestions = [
        visibilityComponents.faqQuestions.faqQuestionReviews ? {
            "@type": "Question",
            name: translate("profile.question_reviews", {
                name: nameSchema,
                skipBold: true
            }),
            acceptedAnswer: {
                "@type": "Answer",
                text: translate("profile.answer_reviews", {
                    name: nameSchema,
                    rating: specialist.averageRating
                })
            }
        } : null,
        visibilityComponents.faqQuestions.faqQuestionLanguages ? {
            "@type": "Question",
            name: translate("profile.question_languages", {
                name: nameSchema,
                skipBold: true
            }),
            acceptedAnswer: {
                "@type": "Answer",
                text: translate(specialist.languages.length > 1 ? "profile.answer_languages_multiple" : "profile.answer_languages", {
                    name: nameSchema,
                    language: specialist.languages.slice(0, specialist.languages.length > 1 ? specialist.languages.length - 1 : specialist.languages.length).map(function(lng) {
                        return (0,strings/* capitalise */.Ig)(lng.name);
                    }).join(", "),
                    lastLanguage: (0,strings/* capitalise */.Ig)((ref6 = specialist.languages[specialist.languages.length - 1]) === null || ref6 === void 0 ? void 0 : ref6.name)
                })
            }
        } : null,
        visibilityComponents.faqQuestions.faqQuestionWhereLocated && {
            "@type": "Question",
            name: translate("profile.question_where_located", {
                name: nameSchema,
                skipBold: true
            }),
            acceptedAnswer: {
                "@type": "Answer",
                text: translate("profile.practices_located_at", {
                    name: nameSchema,
                    practice: mainPractice === null || mainPractice === void 0 ? void 0 : (ref7 = mainPractice.name) === null || ref7 === void 0 ? void 0 : ref7[lang],
                    address: (0,utils_address/* transformAddressToString */.CU)(mainPractice === null || mainPractice === void 0 ? void 0 : mainPractice.address, lang)
                })
            }
        },
        visibilityComponents.faqQuestions.faqQuestionAcceptVisits && {
            "@type": "Question",
            name: translate("profile.question_accept_visits", {
                name: nameSchema,
                skipBold: true
            }),
            acceptedAnswer: {
                "@type": "Answer",
                text: [
                    translate("profile.answer_accept_visits", {
                        name: nameSchema
                    }),
                    translate("get_in_touch"),
                    translate("profile.short_enquire_as_a_new_patient_specialist")
                ].join(" ")
            }
        }
    ];
    var faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqQuestions.filter(Boolean)
    };
    return JSON.stringify([
        _objectSpread({
            "@type": "Physician",
            "@context": "http://schema.org",
            "@id": idSchema,
            url: idSchema,
            name: nameSchema,
            description: aboutSchema,
            image: (0,getImageFromNextImage/* default */.Z)((ref8 = specialist.images) === null || ref8 === void 0 ? void 0 : ref8.logo),
            telephone: ((ref9 = specialist.phones) === null || ref9 === void 0 ? void 0 : ref9.join(",")) || "",
            hospitalAffiliation: hospitalAffiliationSchema,
            memberOf: memberOfSchema,
            makesOffer: makesOffer,
            potentialAction: potentialActionSchema,
            address: practicesAddressesSchema,
            geo: practicesGeoSchema,
            medicalSpecialty: topLevelKeyword === null || topLevelKeyword === void 0 ? void 0 : (ref10 = topLevelKeyword.name) === null || ref10 === void 0 ? void 0 : ref10[lang]
        }, !specialist.basic && specialist.reviewsTotal > 0 ? {
            aggregateRating: aggregateRatingSchema
        } : {}, !feesString.includes("NaN") ? {
            priceRange: feesString
        } : {})
    ].concat(_toConsumableArray(!visibilityComponents.faq ? [] : [
        faqSchema
    ])));
};

;// CONCATENATED MODULE: ./hooks/useSpecialistSchema.ts





function useSpecialistSchema(specialist) {
    var ref = (0,react.useContext)(AppData/* AppDataContext */.R), locale = ref.locale, language = ref.language, isRtl = ref.isRtl;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var visibilityComponents = (0,useVisibilityComponents/* useVisibilityComponents */.c)({
        specialist: specialist
    });
    return (0,react.useMemo)(function() {
        return getSpecialistSchema(specialist, language, locale, translate, visibilityComponents, isRtl);
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        specialist
    ]);
};

// EXTERNAL MODULE: ./hooks/useGetProfileData.ts + 1 modules
var useGetProfileData = __webpack_require__(46385);
// EXTERNAL MODULE: ./hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(48189);
// EXTERNAL MODULE: ./providers/SearchProfilesPage/types.ts
var types = __webpack_require__(42108);
// EXTERNAL MODULE: ./hooks/useSpecialistPracticesWithAddress.ts
var useSpecialistPracticesWithAddress = __webpack_require__(44188);
// EXTERNAL MODULE: ./utils/getCountryByLocale.ts
var getCountryByLocale = __webpack_require__(89794);
// EXTERNAL MODULE: ./utils/sortLanguages.ts
var sortLanguages = __webpack_require__(75011);
;// CONCATENATED MODULE: ./hooks/useSpecialistPageConfig.tsx
function useSpecialistPageConfig_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSpecialistPageConfig_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useSpecialistPageConfig_arrayLikeToArray(arr);
}
function useSpecialistPageConfig_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useSpecialistPageConfig_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSpecialistPageConfig_toConsumableArray(arr) {
    return useSpecialistPageConfig_arrayWithoutHoles(arr) || useSpecialistPageConfig_iterableToArray(arr) || useSpecialistPageConfig_unsupportedIterableToArray(arr) || useSpecialistPageConfig_nonIterableSpread();
}
function useSpecialistPageConfig_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSpecialistPageConfig_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSpecialistPageConfig_arrayLikeToArray(o, minLen);
}

















// todo: fix complexity
// eslint-disable-next-line complexity
var useSpecialistPageConfig = function(param) {
    var specialist = param.specialist, breadcrumbs = param.breadcrumbs, isUnclaimed = param.isUnclaimed, topKeyword = param.topKeyword, topLocation = param.topLocation, bookingSlots = param.bookingSlots, totalReviews = param.totalReviews, address = param.address;
    var ref16, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref11.language, locale = ref11.locale;
    var theme = (0,useTheme_esm/* default */.Z)();
    var specSchema = useSpecialistSchema(specialist);
    var translate = (0,useTranslateMessage/* default */.Z)();
    var isMobile = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var isLaptop = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("lg"));
    var newPersistentPanelEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().newPersistentPanelEnabled;
    var profileVideo = (ref16 = specialist.media) === null || ref16 === void 0 ? void 0 : ref16.filter(function(media) {
        return media.type === "profile" && media.enabled;
    })[0];
    var profileName1 = (0,react.useMemo)(function() {
        var profileName = "";
        if (specialist.title[language]) {
            profileName = specialist.title[language] + " ";
        }
        return profileName + specialist.fullName[language];
    }, [
        language,
        specialist.fullName,
        specialist.title
    ]);
    var visibilityComponents = (0,useVisibilityComponents/* useVisibilityComponents */.c)({
        specialist: specialist,
        address: address
    });
    var introVideoAvailable = (0,react.useMemo)(function() {
        return Boolean(!isUnclaimed && visibilityComponents.introductionVideoAvailable && profileVideo);
    }, [
        isUnclaimed,
        profileVideo,
        visibilityComponents.introductionVideoAvailable
    ]);
    var publications = (ref1 = specialist.media) === null || ref1 === void 0 ? void 0 : ref1.filter(function(media) {
        return media.type === "publication" && media.enabled;
    });
    var specialistTitle = ((ref2 = specialist.title) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[language]) === null || ref3 === void 0 ? void 0 : ref3.length) > 1 ? specialist.title[language] : undefined;
    var specialistSuffix = ((ref4 = specialist.suffix) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[language]) === null || ref5 === void 0 ? void 0 : ref5.length) > 1 ? specialist.suffix[language] : undefined;
    var contacts = (0,useGetProfileData/* useGetContactsData */.kx)({
        specialistData: specialist
    });
    var lastBreadcrumb = breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.at(-1);
    var lastBreadcrumbLocation = lastBreadcrumb ? (0,strings/* capitalise */.Ig)(decodeURIComponent(decodeURI(lastBreadcrumb.label || language))) : "";
    var defaultSpecialistLabel = lastBreadcrumb ? translate("search.breadcrumb_location", {
        name: (topKeyword === null || topKeyword === void 0 ? void 0 : topKeyword.id) === 1 ? translate("search.all_specialists") : ((topKeyword === null || topKeyword === void 0 ? void 0 : topKeyword.practitioner) ? "".concat((topKeyword === null || topKeyword === void 0 ? void 0 : (ref6 = topKeyword.practitioner) === null || ref6 === void 0 ? void 0 : ref6[language]) || (topKeyword === null || topKeyword === void 0 ? void 0 : (ref7 = topKeyword.practitioner) === null || ref7 === void 0 ? void 0 : ref7.en), "s") : topKeyword === null || topKeyword === void 0 ? void 0 : topKeyword.name[language]) || "",
        location: (0,strings/* capitalise */.Ig)(decodeURIComponent(decodeURI(lastBreadcrumb.label || language)))
    }) : "";
    var getBreadcrumbLabel = function() {
        if (specialist.type === types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare) {
            return translate("search.breadcrumb_location", {
                name: translate("home-care-spec"),
                location: lastBreadcrumbLocation
            });
        }
        return defaultSpecialistLabel;
    };
    var specialistBreadcrumb = lastBreadcrumb ? {
        label: getBreadcrumbLabel(),
        url: lastBreadcrumb.url,
        id: lastBreadcrumb.id
    } : undefined;
    var mappedBreadcrumbs = (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && specialistBreadcrumb ? useSpecialistPageConfig_toConsumableArray(breadcrumbs.slice(0, -1)).concat([
        specialistBreadcrumb
    ]) : [];
    var pageSchema = (0,useBreadcrumbsSchema/* default */.Z)(specSchema, mappedBreadcrumbs);
    var practicesWithContactDetails = (0,useSpecialistPractices/* useSpecialistPracticesContacts */.t)(specialist.practices).practicesWithContactDetails;
    var ref12 = (0,useStatistic/* default */.Z)(specialist.statistic), reviewStatistic = ref12.reviewStatistic, peerRecommendationStatistic = ref12.peerRecommendationStatistic, mergedStatistic = ref12.mergedStatistic;
    var isBookingAvailable = !!bookingSlots.length;
    var showBookButton = contacts.some(function(contact) {
        var ref;
        return (ref = contact.externalBookingLink) === null || ref === void 0 ? void 0 : ref.length;
    });
    var showEmailButton = contacts.some(function(contact) {
        var ref;
        return (ref = contact.email) === null || ref === void 0 ? void 0 : ref.length;
    });
    var showPhoneButton = contacts.some(function(contact) {
        var ref;
        return (ref = contact.phone) === null || ref === void 0 ? void 0 : ref.length;
    });
    var onlineBookingAvailable = !!(bookingSlots === null || bookingSlots === void 0 ? void 0 : bookingSlots.length);
    var alternativeBookAppointmentVisibilityCondition = !showBookButton && !onlineBookingAvailable;
    var hideBookAppointmentButton = newPersistentPanelEnabled ? alternativeBookAppointmentVisibilityCondition : false;
    var hideBookAppointment = !showBookButton && !showEmailButton && !showPhoneButton;
    var keywords = (0,useKeywordsMapper/* useTopLevelKeywords */.F)(specialist.keywords || []);
    var topKeywordName = (topKeyword === null || topKeyword === void 0 ? void 0 : topKeyword.name[language].toLowerCase()) || "";
    var maxTopKeywordLength = function() {
        if (language === "de") {
            return 10;
        } else {
            return 20;
        }
    }();
    var topKeywordLengthIsTooLong = topKeywordName.length > maxTopKeywordLength;
    var otherSpecialistsButtonText = translate(topKeywordLengthIsTooLong ? "other.specialists.buttonText.withoutKeyword" : "other.specialsts.buttonText", {
        keyword: topKeywordLengthIsTooLong ? "" : topKeywordName,
        location: ""
    });
    var otherPracticesButtonText = translate(topKeywordLengthIsTooLong ? "other.practices.buttonText.withoutKeyword" : "other.practices.buttonText", {
        keyword: topKeywordLengthIsTooLong ? "" : topKeywordName,
        location: ""
    });
    var urlKeyword = (topKeyword === null || topKeyword === void 0 ? void 0 : (ref8 = topKeyword.slug) === null || ref8 === void 0 ? void 0 : ref8[0]) || "all";
    var defaultCountry = (0,getCountryByLocale/* default */.Z)(locale);
    var ref13;
    var otherSpecialistSearchUrl = "/".concat(locale, "/find/").concat(urlKeyword, "/").concat((ref13 = topLocation === null || topLocation === void 0 ? void 0 : topLocation.slug) !== null && ref13 !== void 0 ? ref13 : defaultCountry, "/specialists");
    var ref14;
    var otherPracticesSearchUrl = "/".concat(locale, "/find/").concat(urlKeyword, "/").concat((ref14 = topLocation === null || topLocation === void 0 ? void 0 : topLocation.slug) !== null && ref14 !== void 0 ? ref14 : defaultCountry, "/practices");
    var filteredPractices = (0,useSpecialistPracticesWithAddress/* useSpecialistPracticesWithAddress */.D)(specialist.practices).filteredPractices;
    var profileAnalytics = {
        profile: {
            prf_type: specialist.plan,
            prf_practice_count: filteredPractices.length,
            prf_book_button: isBookingAvailable,
            prf_contact_email: showEmailButton,
            prf_contact_phone: showPhoneButton,
            prf_booking_link: showBookButton,
            prf_media_centre: visibilityComponents.media,
            prf_uuid: specialist.externalId,
            prf_specialty: keywords,
            prf_practice_type: undefined,
            // false for now as described in doc
            prf_facilities: false
        },
        review: {
            rvw_count: ((ref9 = specialist.reviewsTotal) === null || ref9 === void 0 ? void 0 : ref9.toString()) || "0",
            vw_score: ((ref10 = specialist.averageRating) === null || ref10 === void 0 ? void 0 : ref10.toString()) || "0"
        }
    };
    var sortedLanguages = (0,react.useMemo)(function() {
        return (0,sortLanguages/* default */.Z)(specialist.languages, language);
    }, [
        language,
        specialist.languages
    ]);
    var bookingCalendarSpecialistProfile = (0,react.useMemo)(function() {
        return {
            id: specialist.id,
            externalId: specialist.externalId,
            name: specialist.fullName[language],
            rating: specialist.averageRating,
            reviewsNumber: totalReviews,
            specialty: keywords,
            title: specialist.title[language],
            imageSrc: specialist.images.logo,
            pageLink: "/".concat(locale, "/specialist/").concat(specialist.slug)
        };
    }, [
        keywords,
        language,
        locale,
        specialist.averageRating,
        specialist.externalId,
        specialist.fullName,
        specialist.id,
        specialist.images.logo,
        specialist.slug,
        specialist.title,
        totalReviews
    ]);
    var ref15;
    var bookingCalendarSpecialistPractices = (0,react.useMemo)(function() {
        return specialist.practices.map(function(specialistPractice) {
            var ref, ref17, ref18;
            return {
                id: specialistPractice.id,
                name: (ref = specialistPractice.name) === null || ref === void 0 ? void 0 : ref[language],
                rating: specialistPractice.reviews.overallExperience,
                reviewsNumber: (ref15 = (ref17 = specialistPractice.reviews) === null || ref17 === void 0 ? void 0 : ref17.reviewsTotal) !== null && ref15 !== void 0 ? ref15 : 0,
                contactNumber: (ref18 = specialistPractice.contactDetailsPractice) === null || ref18 === void 0 ? void 0 : ref18.phone
            };
        });
    }, [
        language,
        specialist.practices
    ]);
    var bookingCalendarSlots = (0,react.useMemo)(function() {
        return specialist.practices.map(function(specialistPractice) {
            return {
                practiceId: specialistPractice.id,
                slots: bookingSlots.filter(function(f) {
                    return f.practice.id === specialistPractice.id;
                })
            };
        });
    }, [
        specialist.practices,
        bookingSlots
    ]);
    var bookingCalendarVisitReasons = (0,react.useMemo)(function() {
        return [
            {
                name: "Select",
                value: null
            }
        ].concat(useSpecialistPageConfig_toConsumableArray(specialist.keywords.map(function(keyword) {
            var ref;
            return {
                name: (ref = keyword.name) === null || ref === void 0 ? void 0 : ref[language],
                value: String(keyword.id)
            };
        })), [
            {
                name: "Other",
                value: "other"
            }
        ]);
    }, [
        language,
        specialist.keywords
    ]);
    return {
        isMobile: isMobile,
        isLaptop: isLaptop,
        profileVideo: profileVideo,
        profileName: profileName1,
        visibilityComponents: visibilityComponents,
        introVideoAvailable: introVideoAvailable,
        publications: publications,
        specialistTitle: specialistTitle,
        specialistSuffix: specialistSuffix,
        contacts: contacts,
        mappedBreadcrumbs: mappedBreadcrumbs,
        pageSchema: pageSchema,
        practicesWithContactDetails: practicesWithContactDetails,
        reviewStatistic: reviewStatistic,
        peerRecommendationStatistic: peerRecommendationStatistic,
        mergedStatistic: mergedStatistic,
        hideBookAppointment: hideBookAppointment,
        hideBookAppointmentButton: hideBookAppointmentButton,
        otherSpecialistsButtonText: otherSpecialistsButtonText,
        otherPracticesButtonText: otherPracticesButtonText,
        otherSpecialistSearchUrl: otherSpecialistSearchUrl,
        otherPracticesSearchUrl: otherPracticesSearchUrl,
        profileAnalytics: profileAnalytics,
        sortedLanguages: sortedLanguages,
        bookingCalendarSpecialistProfile: bookingCalendarSpecialistProfile,
        bookingCalendarSpecialistPractices: bookingCalendarSpecialistPractices,
        bookingCalendarSlots: bookingCalendarSlots,
        bookingCalendarVisitReasons: bookingCalendarVisitReasons
    };
};


/***/ }),

/***/ 44188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useSpecialistPracticesWithAddress; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);

var useSpecialistPracticesWithAddress = function(specialistPractices) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!specialistPractices) {
            return {
                filteredPractices: []
            };
        }
        return {
            filteredPractices: specialistPractices.filter(function(practice) {
                var ref;
                return !!((ref = practice.address) === null || ref === void 0 ? void 0 : ref.googlePlaceId);
            })
        };
    }, [
        specialistPractices
    ]);
};


/***/ }),

/***/ 13304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rh": function() { return /* binding */ BookingCalendarProvider; },
/* harmony export */   "wZ": function() { return /* binding */ useBookingCalendar; }
/* harmony export */ });
/* unused harmony export prfStepValues */
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5001);
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72520);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32735);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35837);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8837);
/* harmony import */ var _api_specialist__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10228);
/* harmony import */ var _utils_getConfigVariable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81027);
/* harmony import */ var _utils_captcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6806);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var allLocations = "all locations";
var prfStepValues = {
    search: "search",
    0: "profile",
    1: "date select",
    2: "time select",
    3: "request booking",
    4: "request sent",
    5: "error",
    6: "error"
};
var BookingCalendarContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(undefined);
var findPracticeSlots = function(slots, practice) {
    var ref, ref1;
    if (!practice) {
        return [];
    }
    var ref2;
    return (ref2 = slots === null || slots === void 0 ? void 0 : (ref = slots.find) === null || ref === void 0 ? void 0 : (ref1 = ref.call(slots, function(f) {
        return f.practiceId === (practice === null || practice === void 0 ? void 0 : practice.id);
    })) === null || ref1 === void 0 ? void 0 : ref1.slots) !== null && ref2 !== void 0 ? ref2 : [];
};
var findDefaultPractice = function() {
    var slots = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], practices = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = practices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var practice = _step.value;
            var practiceSlots = findPracticeSlots(slots, practice);
            if (practiceSlots.length) {
                return practice;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
};
var GOOGLE_CAPTCHA_KEY = (0,_utils_getConfigVariable__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("BOOK_ACTIONS_GOOGLE_CAPTCHA_KEY");
var googleRecaptcha = new _utils_captcha__WEBPACK_IMPORTED_MODULE_7__/* .GoogleRecaptcha */ .k(GOOGLE_CAPTCHA_KEY);
var getBookResponseMeta = function(success, status) {
    var event = "prf_pg_book_calndr_time_slot_error";
    var screen = _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.SLOT_NOT_AVAILABLE */ .vl.SLOT_NOT_AVAILABLE;
    if (status === 405) {
        event = "prf_pg_book_calndr_captcha_error";
        screen = _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.CAPTCHA_ERROR */ .vl.CAPTCHA_ERROR;
    }
    if (success) {
        event = "prf_pg_book_calndr_confrm";
        screen = _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.SUCCESS_APPOINTMENT */ .vl.SUCCESS_APPOINTMENT;
    }
    return {
        event: event,
        screen: screen
    };
};
var BookingCalendarProvider = function(param) {
    var _slots = param.slots, slots = _slots === void 0 ? [] : _slots, specialistProfile = param.specialistProfile, practices = param.practices, toggleBookingModal = param.toggleBookingModal, visitReasons = param.visitReasons, children = param.children, _insurances = param.insurances, insurances = _insurances === void 0 ? [] : _insurances;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        practiceProfile: findDefaultPractice(slots, practices),
        practices: practices,
        specialistProfile: specialistProfile,
        slots: findPracticeSlots(slots, findDefaultPractice(slots, practices)),
        visitReasons: visitReasons,
        currentScreen: _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.CALENDAR_PREVIEW */ .vl.CALENDAR_PREVIEW,
        selectedInsurance: {
            value: null,
            label: "Select"
        },
        selectedSlot: null,
        selectedDateString: undefined,
        selectedTimeString: undefined
    }), state = ref7[0], setState = ref7[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_types__WEBPACK_IMPORTED_MODULE_4__/* .LOCATION_MODAL_VARIANTS.NONE */ .F.NONE), locationModalVariant = ref3[0], setLocationModalVariant = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.NONE */ .R.NONE), modalVariant = ref4[0], setModalVariant = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isFullScreenMode = ref5[0], setIsFullScreenMode = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isInsuranceModalOpen = ref6[0], setIsInsuranceModalOpen = ref6[1];
    var countPrfStepValue = prfStepValues[state.currentScreen];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, _practiceProfile;
        setState(function(prev) {
            return _objectSpread({}, prev, {
                practice: (ref = practices[0]) !== null && ref !== void 0 ? ref : prev.practiceProfile,
                slots: findPracticeSlots(slots, (_practiceProfile = prev.practiceProfile) !== null && _practiceProfile !== void 0 ? _practiceProfile : practices[0]).filter(function(slot) {
                    var bookedSlotFromLocalStorage = localStorage.getItem("slot-".concat(slot.id, "-").concat(specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.id));
                    if (bookedSlotFromLocalStorage === slot.id) {
                        return false;
                    }
                    return slot;
                }),
                visitReasons: visitReasons !== null && visitReasons !== void 0 ? visitReasons : prev.visitReasons,
                specialist: specialistProfile !== null && specialistProfile !== void 0 ? specialistProfile : prev.specialistProfile
            });
        });
    }, [
        practices,
        slots,
        specialistProfile,
        visitReasons
    ]);
    var getPracticeSlots = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(practiceId) {
        var practice = practices.find(function(p) {
            return p.id === practiceId;
        });
        return findPracticeSlots(slots, practice);
    }, [
        slots,
        practices
    ]);
    var displayPracticeSelector = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var practicesWithSlotsCount = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = slots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var slot = _step.value;
                var practiceSlots = getPracticeSlots(slot.practiceId);
                if (practiceSlots.length) {
                    practicesWithSlotsCount += 1;
                }
                if (practicesWithSlotsCount > 1) {
                    return true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    }, [
        getPracticeSlots,
        slots
    ]);
    var handleExpandButtonClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setModalVariant(function(prev) {
            return prev === _types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.FULL_SCREEN */ .R.FULL_SCREEN ? _types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.SIDE_MODAL */ .R.SIDE_MODAL : _types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.FULL_SCREEN */ .R.FULL_SCREEN;
        });
        setIsFullScreenMode(function(prev) {
            return !prev;
        });
    }, []);
    var handleInsuranceSelectionClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(insurance) {
        return setState(function(prev) {
            return _objectSpread({}, prev, {
                selectedInsurance: insurance ? {
                    value: insurance.id,
                    label: insurance.name
                } : {
                    value: null,
                    label: "Select"
                }
            });
        });
    }, []);
    var handleDateSelectionClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(dateString) {
        if (specialistProfile && dateString) {
            window.dataLayer.push({
                event: "prf_pg_book_calndr_interaction",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_prf_uuid: specialistProfile.id.toString(),
                cont_interaction_label: "date selected",
                cont_prf_step: countPrfStepValue
            });
        }
        setState(function(prev) {
            return _objectSpread({}, prev, {
                selectedDateString: dateString
            });
        });
    }, [
        specialistProfile,
        countPrfStepValue
    ]);
    var handleTimeSelectionClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(timeString, triggerSource) {
        var isProfile = triggerSource === "profile";
        if (specialistProfile) {
            window.dataLayer.push({
                event: "prf_pg_book_calndr_interaction",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_prf_uuid: specialistProfile.id.toString(),
                cont_interaction_label: isProfile ? "time slot confirm " : "time slot selected",
                cont_prf_step: countPrfStepValue
            });
        }
        setState(function(prev) {
            return _objectSpread({}, prev, {
                selectedTimeString: timeString
            });
        });
    }, [
        specialistProfile,
        countPrfStepValue
    ]);
    var handleSlotSelectionClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(slot) {
        return setState(function(prev) {
            return _objectSpread({}, prev, {
                selectedSlot: slot !== null && slot !== void 0 ? slot : null
            });
        });
    }, []);
    var changeScreen = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(screen) {
        switch(screen){
            case _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.CALENDAR_PREVIEW */ .vl.CALENDAR_PREVIEW:
                {
                    setModalVariant(_types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.NONE */ .R.NONE);
                    break;
                }
            case _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.DATE_SELECTION */ .vl.DATE_SELECTION:
                {
                    setModalVariant(isFullScreenMode ? _types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.FULL_SCREEN */ .R.FULL_SCREEN : _types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.SIDE_MODAL */ .R.SIDE_MODAL);
                    break;
                }
            case _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.SLOT_SELECTION */ .vl.SLOT_SELECTION:
                setModalVariant(isFullScreenMode ? _types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.FULL_SCREEN */ .R.FULL_SCREEN : _types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.SIDE_MODAL */ .R.SIDE_MODAL);
                break;
            case _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.SLOT_NOT_AVAILABLE */ .vl.SLOT_NOT_AVAILABLE:
            case _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.BOOKING_FORM */ .vl.BOOKING_FORM:
            case _hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.SUCCESS_APPOINTMENT */ .vl.SUCCESS_APPOINTMENT:
            default:
                setModalVariant(_types__WEBPACK_IMPORTED_MODULE_4__/* .MODAL_VARIANTS.FULL_SCREEN */ .R.FULL_SCREEN);
        }
        setState(function(prev) {
            return _objectSpread({}, prev, {
                currentScreen: screen
            });
        });
    }, [
        isFullScreenMode
    ]);
    var handleBookButtonClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(formData) {
            var captchaHeaders, ref9, success, status, ref8, event, resultScreen;
            return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return googleRecaptcha.handleWithValidation();
                    case 2:
                        captchaHeaders = _ctx.sent;
                        _ctx.next = 5;
                        return (0,_api_specialist__WEBPACK_IMPORTED_MODULE_5__/* .bookSpecialistSlot */ .f8)({
                            data: formData,
                            lang: router.locale,
                            id: specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.id,
                            requestHeaders: captchaHeaders
                        }).then(function(response) {
                            setState(function(prevState) {
                                var ref;
                                var slotsWithoutBookedSlot = (ref = prevState.slots) === null || ref === void 0 ? void 0 : ref.filter(function(slot) {
                                    return slot.id !== formData.availabilityId;
                                });
                                localStorage.setItem("slot-".concat(formData.availabilityId, "-").concat(specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.id), formData.availabilityId);
                                return _objectSpread({}, prevState, {
                                    slots: slotsWithoutBookedSlot
                                });
                            });
                            return response;
                        });
                    case 5:
                        ref9 = _ctx.sent;
                        success = ref9.success;
                        status = ref9.status;
                        ref8 = getBookResponseMeta(success, status), event = ref8.event, resultScreen = ref8.screen;
                        if (specialistProfile && practices) {
                            window.dataLayer.push({
                                event: event,
                                cont_prf_name: specialistProfile.name || "",
                                cont_prf_type: "Specialist",
                                cont_prf_uuid: specialistProfile.id.toString(),
                                cont_enquired_at_name: practices[0].name,
                                cont_enquired_at_uuid: practices[0].id.toString()
                            });
                        }
                        changeScreen(resultScreen);
                        return _ctx.abrupt("return", success);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(formData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        changeScreen,
        practices,
        router.locale,
        specialistProfile
    ]);
    var handleContactRequestClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (specialistProfile) {
            window.dataLayer.push({
                event: "prf_pg_cont_button",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_interaction_label: "Contact",
                cont_prf_uuid: specialistProfile.externalId || ""
            });
        }
        setLocationModalVariant(_types__WEBPACK_IMPORTED_MODULE_4__/* .LOCATION_MODAL_VARIANTS.CONTACT */ .F.CONTACT);
        toggleBookingModal();
    }, [
        toggleBookingModal,
        specialistProfile
    ]);
    var handleProfileSelectionClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (specialistProfile) {
            window.dataLayer.push({
                event: "prf_pg_book_calndr_interaction",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_prf_uuid: specialistProfile.id.toString(),
                cont_interaction_label: "location drop down click",
                cont_prf_step: countPrfStepValue
            });
        }
        if (displayPracticeSelector) {
            setLocationModalVariant(_types__WEBPACK_IMPORTED_MODULE_4__/* .LOCATION_MODAL_VARIANTS.PROFILE_SELECTION */ .F.PROFILE_SELECTION);
            toggleBookingModal();
        } else {
            changeScreen(_hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.DATE_SELECTION */ .vl.DATE_SELECTION);
        }
    }, [
        specialistProfile,
        displayPracticeSelector,
        countPrfStepValue,
        toggleBookingModal,
        changeScreen
    ]);
    var closeProfileSelectionModal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setLocationModalVariant(_types__WEBPACK_IMPORTED_MODULE_4__/* .LOCATION_MODAL_VARIANTS.NONE */ .F.NONE);
        toggleBookingModal();
    }, [
        toggleBookingModal
    ]);
    var handleSlotNotAvailableBackClick = function() {
        if (specialistProfile) {
            window.dataLayer.push({
                event: "prf_pg_book_calndr_interaction",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_prf_uuid: specialistProfile.id.toString(),
                cont_interaction_label: "find another slot click",
                cont_prf_step: countPrfStepValue
            });
        }
        changeScreen(_hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.CALENDAR_PREVIEW */ .vl.CALENDAR_PREVIEW);
    };
    var handlePracticeChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
        if (specialistProfile) {
            window.dataLayer.push({
                event: "prf_pg_book_popup_book_cal_start",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_enquired_at_name: allLocations,
                cont_enquired_at_uuid: allLocations,
                cont_prf_uuid: specialistProfile.id.toString(),
                cont_interaction_label: "book this practice",
                cont_prf_step: prfStepValues.search
            });
        }
        changeScreen(_hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.DATE_SELECTION */ .vl.DATE_SELECTION);
        setState(function(prev) {
            var selectedPractice = practices.find(function(f) {
                return f.id === id;
            });
            return _objectSpread({}, prev, {
                practiceProfile: selectedPractice,
                slots: findPracticeSlots(slots, selectedPractice)
            });
        });
    }, [
        changeScreen,
        practices,
        slots,
        specialistProfile
    ]);
    var handleInsuranceSelectClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setIsInsuranceModalOpen(function(prev) {
            return !prev;
        });
    }, []);
    var isBookingAvailable = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var defaultPractice = findDefaultPractice(slots, practices);
        return !!defaultPractice;
    }, [
        practices,
        slots
    ]);
    var handleShowMoreDatesClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (specialistProfile) {
            window.dataLayer.push({
                event: "prf_pg_book_popup_book_cal_start",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_enquired_at_name: allLocations,
                cont_enquired_at_uuid: allLocations,
                cont_prf_uuid: specialistProfile.id.toString(),
                cont_interaction_label: "more dates arrow",
                cont_prf_step: countPrfStepValue
            });
        }
        changeScreen(_hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.DATE_SELECTION */ .vl.DATE_SELECTION);
    }, [
        changeScreen,
        countPrfStepValue,
        specialistProfile
    ]);
    var handleShowMoreSlotsClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (specialistProfile) {
            window.dataLayer.push({
                event: "prf_pg_book_calndr_interaction",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_prf_uuid: specialistProfile.id.toString(),
                cont_interaction_label: "more time slots",
                cont_prf_step: countPrfStepValue
            });
        }
        changeScreen(_hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.SLOT_SELECTION */ .vl.SLOT_SELECTION);
    }, [
        changeScreen,
        countPrfStepValue,
        specialistProfile
    ]);
    var handleViewAllAvailabilityClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (specialistProfile) {
            window.dataLayer.push({
                event: "prf_pg_book_calndr_interaction",
                cont_prf_name: specialistProfile.name || "",
                cont_prf_type: "Specialist",
                cont_prf_uuid: specialistProfile.id.toString(),
                cont_interaction_label: "view all availability",
                cont_prf_step: countPrfStepValue
            });
        }
        changeScreen(_hermes_booking_calendar__WEBPACK_IMPORTED_MODULE_8__/* .SCREENS.SLOT_SELECTION */ .vl.SLOT_SELECTION);
    }, [
        changeScreen,
        countPrfStepValue,
        specialistProfile
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BookingCalendarContext.Provider, {
        value: {
            state: state,
            insurances: insurances,
            isFullScreenMode: isFullScreenMode,
            isBookingAvailable: isBookingAvailable,
            isInsuranceModalOpen: isInsuranceModalOpen,
            modalVariant: modalVariant,
            countPrfStepValue: countPrfStepValue,
            locationModalVariant: locationModalVariant,
            closeProfileSelectionModal: closeProfileSelectionModal,
            setModalVariant: setModalVariant,
            getPracticeSlots: getPracticeSlots,
            displayPracticeSelector: displayPracticeSelector,
            handleBookButtonClick: handleBookButtonClick,
            handleExpandButtonClick: handleExpandButtonClick,
            handleContactRequestClick: handleContactRequestClick,
            handleInsuranceSelectionClick: handleInsuranceSelectionClick,
            handleDateSelectionClick: handleDateSelectionClick,
            handleTimeSelectionClick: handleTimeSelectionClick,
            handleProfileSelectionClick: handleProfileSelectionClick,
            handleSlotNotAvailableBackClick: handleSlotNotAvailableBackClick,
            handleSlotSelectionClick: handleSlotSelectionClick,
            handlePracticeChange: handlePracticeChange,
            handleInsuranceSelectClick: handleInsuranceSelectClick,
            handleShowMoreDatesClick: handleShowMoreDatesClick,
            handleShowMoreSlotsClick: handleShowMoreSlotsClick,
            handleViewAllAvailabilityClick: handleViewAllAvailabilityClick,
            changeScreen: changeScreen
        },
        children: children
    });
};
var useBookingCalendar = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(BookingCalendarContext);
    if (!context) {
        throw new Error("useBookingCalendar must be used within a BookingCalendarProvider");
    }
    return context;
};


/***/ }),

/***/ 75011:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var sortLanguages = function(languages, language) {
    return languages.sort(function(a, b) {
        var isDefaultA = a.isoCode === language;
        var isDefaultB = b.isoCode === language;
        if (isDefaultA !== isDefaultB) {
            return isDefaultA ? -1 : 1;
        }
        var isEnglishA = a.isoCode === "en";
        var isEnglishB = b.isoCode === "en";
        if (isEnglishA !== isEnglishB) {
            return isEnglishA ? -1 : 1;
        }
        return a.name.localeCompare(b.name);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (sortLanguages);


/***/ })

}]);